var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerCareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 4.5,
    fill: "white",
    stroke: "#F8F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3232 11.7234L14.1716 12.5718C15.7343 11.0094 18.2665 11.0094 19.8284 12.5718L20.6776 11.7234C18.6462 9.69223 15.3546 9.69223 13.3232 11.7234Z",
    fill: "url(#paint0_linear_3872_1245)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 15.3999C25.0003 10.9813 21.42 7.39999 17.0004 7.39999C12.582 7.39999 9.00047 10.9813 9.00047 15.3999C8.5761 15.3999 8.16912 15.5685 7.86904 15.8686C7.56897 16.1686 7.40039 16.5756 7.40039 17V21.8C7.40039 22.2244 7.56897 22.6313 7.86904 22.9314C8.16912 23.2315 8.5761 23.4001 9.00047 23.4001H11.4005C11.5055 23.4001 11.6096 23.3794 11.7067 23.3392C11.8038 23.299 11.892 23.2401 11.9663 23.1658C12.0405 23.0915 12.0995 23.0032 12.1396 22.9061C12.1798 22.809 12.2005 22.705 12.2004 22.5999V18.6001C12.2004 18.1602 12.0007 17.4999 11.7566 17.1344L10.6006 15.4002C10.6006 11.865 13.4657 9.00007 17.0006 9.00007C20.5365 9.00007 23.4007 11.865 23.4007 15.4002L22.2444 17.1344C22.0003 17.4999 21.8004 18.1602 21.8004 18.6001V22.8236C20.6277 24.1556 18.9146 24.9999 17.0004 24.9999H15.4003V26.6H17.0004C19.6159 26.6 21.93 25.3398 23.3894 23.4001H25.0003C25.4247 23.4001 25.8317 23.2315 26.1317 22.9314C26.4318 22.6313 26.6004 22.2244 26.6004 21.8V17C26.6004 16.5756 26.4318 16.1686 26.1317 15.8686C25.8317 15.5685 25.4247 15.3999 25.0003 15.3999Z",
    fill: "url(#paint1_linear_3872_1245)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3872_1245",
    x1: 17.0004,
    y1: 10.2,
    x2: 17.0004,
    y2: 12.5718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3872_1245",
    x1: 17.0004,
    y1: 7.39999,
    x2: 17.0004,
    y2: 26.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCareIcon);
export default __webpack_public_path__ + "static/media/customerCare-icon.8a5218990c2355be8db2de9de3543cf1.svg";
export { ForwardRef as ReactComponent };